<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SkillDetail from '../../../../../skills/components/SkillDetail.vue'
import { SkillID } from '../../../../../skills/models/skill'

definePage({
    props: true,
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        featureFlags: 'skills',
    }
})

const {
  id,
} = defineProps<{
    id: SkillID
}>()
</script>

<template>
  <SkillDetail
    :id="id"
  />
</template>